export default __webpack_public_path__ + "static/media/Leggings of Deadly Guile.e8c7ab0c.jpg";